<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
          <div class="col green">
            <h3><i class="fas fa-hand-holding-usd"></i> Offering Status</h3>
          </div>
          <div class="text-right">
            <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> More Info</a>
          </div>
      </div>
    </div>
    <div class="card-body bid-detail">
      <canvas id="offeringstatus"></canvas>
    </div>
  </div> 
</template>
<script>
import authService from "@/authService";
import config from "@/config";
export default {
  name: "offeringStatusWidget",
  data() {
    return {
      offerStatusChartOptions: {
        type: 'bar',
        data: {
          labels: [],
          datasets: [{
            label: '',
            data: [],
            backgroundColor: "#0084CC",
            barPercentage: 0.2,
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                userCallback: function(label) {
                  // when the floored value is the same as the value we have a whole number
                  if (Math.floor(label) === label) {
                      return label;
                  }

              },
              },
              scaleLabel: {
                display: true,
                labelString: ''
              }

            }],
            xAxes: [{
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              },
              scaleLabel: {
                display: true,
                labelString: ''
              }

            }, ]
          },
          legend: {
            display: false
          },
          plugins: {
            labels: {
              render: function () {
                return '';
              },
            }
          } 
        }
      },
      myChart : null,
      offerStatus : {},
      isAdmin: false,
      isTrader : false,
      isEditor : false
    };
  },
  methods: {
     navigateListPage(){
       window.location.href = "/ims/ims-offering";
    },
    setOfferingData(){
      this.offerStatusChartOptions.data.labels = ["HOLD","SUSPENDED","STATIC","REJECTED","MSRB","LIVE"]
      this.offerStatusChartOptions.data.datasets[0].data = [
        this.offerStatus.hold,
        this.offerStatus.suspended,
        this.offerStatus.staticOfferCount,
        this.offerStatus.rejected,
        this.offerStatus.msrb,
        this.offerStatus.live
        ];
      // this.offerStatusChartOptions.data.datasets[0].data = [10,20,30]

      this.offerStatusChartOptions.data.datasets[0].backgroundColor = ["#56b58b", "#ea6f7c", "#7e698f","#E96875","#FF9E47","#56B68B"];
      if(this.myChart){
        this.myChart.destroy();
      }
      const ctx = document.getElementById("offeringstatus");
      this.myChart = new window.Chart(ctx, {
        type: this.offerStatusChartOptions.type,
        data: this.offerStatusChartOptions.data,
        options: this.offerStatusChartOptions.options
      });
    },
     getOfferStatus(){
      this.loading = true;
      let url = "/offer/stats";
      if((!this.isAdmin || !this.isEditor) && this.isTrader){
        url = "/offer/stats?cognitoSub="+authService.getUser().cognitoSub
      }
      const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
      .get(
        config.baseUrlBidSide + url,
          auth
      )
      .then(result => {
        this.offerStatus = result.data;
        this.setOfferingData();
        this.loading = false;
      })

    }
  },
  mounted() {
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          this.getOfferStatus();

        }
        //console.log("isa",this.isAdmin);
      });
    //this.getOfferStatus()
  }
};
</script>